'use strict';

var React = require('react');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var GenericIconWeb = require('@swiggy-private/dls-web-icons/dist/GenericIconWeb');
var helpers = require('./helpers-BjcsXRdQ.js');
var nonveg = require('@swiggy-private/dls-web-food-icons/dist/web/nonveg');
var veg = require('@swiggy-private/dls-web-food-icons/dist/web/veg');
var chevronDown = require('@swiggy-private/dls-web-icons/dist/web/generic/chevronDown');
var styled = require('styled-components');
var _tslib = require('./_tslib-D25eJ2i9.js');
var jsUtils = require('@swiggy-private/js-utils');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const AriaHidden = (_a) => {
    var { as: Component } = _a, props = _tslib.__rest(_a, ["as"]);
    return (React__default.default.createElement(Component, Object.assign({}, props, { "aria-hidden": "true" }),
        props.children,
        " "));
};

const ContainerStyled = styled__default.default.div `
    display: inline;
`;
const NameStyled = styled__default.default.div `
    display: flex;
    align-items: start;
    margin-bottom: -${(props) => props.theme.spacing.xxxSmall};
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    max-height: 3rem;
    overflow: hidden;
    word-break: break-word;
    position: relative;
`;
const FoodSymbolStyled = styled__default.default(GenericIconWeb.GenericIcon)(({ theme }) => ({
    display: "inline-block",
    width: "fit-content",
    height: "fit-content",
    margin: `2px ${theme.spacing.xxSmall} 0px 0px`,
    verticalAlign: "middle",
}));
const FreebieTextStyled = styled__default.default(Text.Text) `
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
`;
const AriaHiddenCustomiseStyled = styled__default.default(AriaHidden) `
    display: flex;
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
const CustomiseTextStyled = styled__default.default(Text.Text) `
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 4px;
`;
const CustomiseButtonStyled = styled__default.default.button `
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    display: flex;
    align-items: center;
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
`;

const UNAVAILABLE = "Unavailable";
const freebieText = "1 Free Delight for you";
const CUSTOMIZE = "Customize";

function ItemInfo(props) {
    const itemCustomiseDetail = React.useMemo(() => helpers.getAddonVariantString(props.addons, props.variants.variantGroups), [props.addons, props.variants.variantGroups]);
    const isVeg = React.useMemo(() => props.vegType === 1, [props.vegType]);
    return (React__default.default.createElement(ContainerStyled, null,
        React__default.default.createElement(NameStyled, null,
            React__default.default.createElement(FoodSymbolStyled, { Icon: isVeg ? veg.Veg12 : nonveg.NonVeg12 }),
            React__default.default.createElement(Text.Text, { variant: "V2.body2.neutral.medium", color: "text_High_Emphasis", maxLines: 2 }, props.name)),
        props.subText && (React__default.default.createElement(Text.Text, { variant: "V2.body3.neutral.regular", color: "text_Low_Emphasis" }, props.subText)),
        props.isFreebie && (React__default.default.createElement(FreebieTextStyled, { variant: "V2.body3.neutral.regular", color: "text_Low_Emphasis" }, freebieText)),
        !jsUtils.isEmpty(itemCustomiseDetail) && (React__default.default.createElement(AriaHiddenCustomiseStyled, { as: "div" },
            React__default.default.createElement(CustomiseTextStyled, { variant: "V2.body3.neutral.regular", color: "text_Low_Emphasis", onClick: props.onCustomise }, itemCustomiseDetail.length > 0 ? itemCustomiseDetail : CUSTOMIZE),
            !props.isGroupOrderFlow && props.isCustomisable && (React__default.default.createElement(CustomiseButtonStyled, { onClick: props.onCustomise },
                React__default.default.createElement(GenericIconWeb.GenericIcon, { Icon: chevronDown.Svg12, fillColor: "text_Low_Emphasis" })))))));
}
var ItemInfo$1 = React.memo(ItemInfo);

exports.ItemInfo = ItemInfo$1;
exports.UNAVAILABLE = UNAVAILABLE;
//# sourceMappingURL=ItemInfo-BZWKuv-x.js.map
